import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../.providers/auth.service';
import { UserService } from '../.providers/user.service';
import { MainService } from '../.providers/main.service';
@Component({
	selector: 'app-login-page',
	templateUrl: './login-page.component.html',
	styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
	constructor(
		public authService: AuthService,
		public userService: UserService,
		public mainService: MainService,
		private router: Router
	) {}
	ngOnInit() {}
	login() {
		debugger;
		this.authService.loginWithGoogle().then(data => {
			debugger;
			console.log(data);
			this.router.navigate(['/home']);
			this.mainService.registerUser();
		});
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/login-page/login-page.component.ts